import { render, staticRenderFns } from "./AllowancesPlanDetails.vue?vue&type=template&id=415b021a&"
import script from "./AllowancesPlanDetails.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports